const initialized = new WeakSet();

/** Field feedback only; native POST handlers remain responsible for authentication and saves. */
export function initializeAccountForms(root, messages) {
    const forms = new Set([...root.querySelectorAll('.woocommerce-form-login, .woocommerce-form-register, .woocommerce-ResetPassword, .woocommerce-EditAccountForm, .woocommerce-address-fields')].map((node) => node.closest('form')));
    forms.forEach((form) => {
        if (!form || initialized.has(form)) return;
        initialized.add(form);
        form.noValidate = true;
        const errors = new Map();
        const fields = () => [...form.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), select, textarea')].filter((field) => field.id && !field.disabled && !field.closest('[hidden]'));
        const clear = (field) => {
            const error = errors.get(field);
            if (!error) return;
            const descriptions = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== error.id);
            if (descriptions.length) field.setAttribute('aria-describedby', descriptions.join(' '));
            else field.removeAttribute('aria-describedby');
            field.removeAttribute('aria-invalid');
            field.closest('.form-row')?.classList.remove('OvAccountField--invalid');
            error.remove();
            errors.delete(field);
        };
        const validate = (field) => {
            clear(field);
            let text = '';
            const required = field.required || field.getAttribute('aria-required') === 'true';
            const empty = ['checkbox', 'radio'].includes(field.type) ? !field.checked : !field.value.trim();
            if (required && empty) text = messages.required;
            else if (field.type === 'email' && field.validity.typeMismatch) text = messages.email;
            const password = form.querySelector('#password_1');
            if (!text && field.id === 'password_2' && password && field.value !== password.value) text = messages.passwordMatch;
            if (!text) return true;
            const error = field.ownerDocument.createElement('span');
            error.className = 'OvAccountField__error';
            error.id = `${field.id}-error`;
            error.textContent = text;
            error.setAttribute('aria-live', 'polite');
            const row = field.closest('.form-row') || field.parentElement;
            row.append(error);
            row.classList.add('OvAccountField--invalid');
            field.setAttribute('aria-invalid', 'true');
            field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
            errors.set(field, error);
            return false;
        };
        form.addEventListener('submit', (event) => {
            const invalid = fields().filter((field) => !validate(field));
            if (!invalid.length) return;
            event.preventDefault();
            invalid[0].focus();
        });
        const update = ({ target }) => {
            if (errors.has(target)) validate(target);
            if (target.id === 'password_1') {
                const confirmation = form.querySelector('#password_2');
                if (confirmation && errors.has(confirmation)) validate(confirmation);
            }
        };
        form.addEventListener('input', update);
        form.addEventListener('change', update);
    });
}
